import { useState } from "react";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import RoleBasedRenderer from "../../components/auth/RoleBasedRenderer";

// Vistas
import FacturasView from "./Facturas/FacturasView";
import IngresosView from "./Ingresos/IngresosView";
import NotasView from "./Notas/NotasView";
// TODO: Uncomment when GastosView is ready
import GastosView from "./Gastos/GastosView";

// Tipos
export type TabId = 'facturas' | 'ingresos' | 'notas' | 'gastos'; // Remove 'gastos' temporarily

const TABS = [
  {
    id: 'facturas' as TabId,
    label: 'Facturas',
    component: FacturasView
  },
  {
    id: 'ingresos' as TabId,
    label: 'Ingresos',
    component: IngresosView,
    adminOnly: true  // Adding a flag to mark this tab as admin-only
  },
  {
    id: 'notas' as TabId,
    label: 'Notas de Crédito/Débito',
    component: NotasView
  },
  {
    id: 'gastos',
    label: 'Gastos y Compras',
    component: GastosView,
    adminOnly: true  // Adding a flag to mark this tab as admin-only
  }
];

export default function Finanzas() {
  const [activeTab, setActiveTab] = useState<TabId>('facturas');
  
  const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component || FacturasView;
  const currentTab = TABS.find(tab => tab.id === activeTab);

  return (
    <div>
      <div className="mb-6">
        <PageBreadcrumb pageTitle="Finanzas" />
      </div>
      
      <PageMeta
        title="Gestión financiera | Destiny Caribbean Tours"
        description="Sistema de gestión financiera integral"
      />
      
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-4 py-6 dark:border-gray-700 dark:bg-gray-800 sm:px-6 lg:px-8">

        {/* Header Section */}
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
            Gestión financiera
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Administre sus facturas, controle ingresos y realice seguimiento de pagos
          </p>
        </div>

        {/* Navigation Tabs */}
        <div className="mb-8 overflow-x-auto">
          <nav className="flex flex-wrap sm:flex-nowrap border-b border-gray-200 dark:border-gray-700">
            {TABS.map((tab) => (
              tab.adminOnly ? (
                <RoleBasedRenderer key={tab.id} requiredRoles={['admin']} fallback={null}>
                  <button
                    onClick={() => setActiveTab(tab.id as TabId)}
                    className={`
                      px-2 sm:px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap
                      flex-grow sm:flex-grow-0
                      ${activeTab === tab.id
                        ? 'border-brand-500 text-brand-600 dark:text-brand-400'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}
                    `}
                  >
                    {tab.label}
                  </button>
                </RoleBasedRenderer>
              ) : (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id as TabId)}
                  className={`
                    px-2 sm:px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap
                    flex-grow sm:flex-grow-0
                    ${activeTab === tab.id
                      ? 'border-brand-500 text-brand-600 dark:text-brand-400'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}
                  `}
                >
                  {tab.label}
                </button>
              )
            ))}
          </nav>
        </div>

        {/* Active View */}
        {currentTab?.adminOnly ? (
          <RoleBasedRenderer requiredRoles={['admin']}>
            <ActiveComponent />
          </RoleBasedRenderer>
        ) : (
          <ActiveComponent />
        )}
      </div>
    </div>
  );
}
